import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const MegaphoneIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="m3 11 17-6v14L3 13v-2z" />
    <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
  </svg>
)
